import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { WebSocketService } from '../../../../client/app/server-communication/services/websocket.service';
import { WebSocketMessageType } from '../../../../model/web-socket-message';
import EventLogsActions from './event-logs.action-types';

@Injectable()
export class EventLogsEffects {
    constructor(private readonly actions$: Actions, private readonly webSocketService: WebSocketService) {}

    requestEventLogs$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(EventLogsActions.requestEventLogs),
                map(action => action.locationContext),
                tap(locationContext => {
                    this.webSocketService.sendMessage(WebSocketMessageType.EventLogs, { locationContext });
                })
            ),
        { dispatch: false }
    );
}
